export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14938.1f7bc1f9.jpg";